import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddNewContainerTypeMutationVariables = Types.Exact<{
  container_type_name: Types.Scalars['String'];
  prices_by_currency_string: Types.Scalars['String'];
  is_white_label?: Types.InputMaybe<Types.Scalars['Boolean']>;
  description?: Types.InputMaybe<Types.Scalars['String']>;
  group_id?: Types.InputMaybe<Types.Scalars['Int']>;
  segment: Types.ContainerTypeSegment;
}>;


export type AddNewContainerTypeMutation = { __typename?: 'Mutation', addNewContainerType?: boolean | null };


export const AddNewContainerTypeDocument = gql`
    mutation AddNewContainerType($container_type_name: String!, $prices_by_currency_string: String!, $is_white_label: Boolean, $description: String, $group_id: Int, $segment: ContainerTypeSegment!) {
  addNewContainerType(
    container_type_name: $container_type_name
    prices_by_currency_string: $prices_by_currency_string
    is_white_label: $is_white_label
    description: $description
    group_id: $group_id
    segment: $segment
  )
}
    `;
export type AddNewContainerTypeMutationFn = Apollo.MutationFunction<AddNewContainerTypeMutation, AddNewContainerTypeMutationVariables>;

/**
 * __useAddNewContainerTypeMutation__
 *
 * To run a mutation, you first call `useAddNewContainerTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewContainerTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewContainerTypeMutation, { data, loading, error }] = useAddNewContainerTypeMutation({
 *   variables: {
 *      container_type_name: // value for 'container_type_name'
 *      prices_by_currency_string: // value for 'prices_by_currency_string'
 *      is_white_label: // value for 'is_white_label'
 *      description: // value for 'description'
 *      group_id: // value for 'group_id'
 *      segment: // value for 'segment'
 *   },
 * });
 */
export function useAddNewContainerTypeMutation(baseOptions?: Apollo.MutationHookOptions<AddNewContainerTypeMutation, AddNewContainerTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNewContainerTypeMutation, AddNewContainerTypeMutationVariables>(AddNewContainerTypeDocument, options);
      }
export type AddNewContainerTypeMutationHookResult = ReturnType<typeof useAddNewContainerTypeMutation>;
export type AddNewContainerTypeMutationResult = Apollo.MutationResult<AddNewContainerTypeMutation>;
export type AddNewContainerTypeMutationOptions = Apollo.BaseMutationOptions<AddNewContainerTypeMutation, AddNewContainerTypeMutationVariables>;